import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useCallback, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Product as ProductHook } from '../../hooks/products';
import ProductSelect from '../../components/ProductSelect';
import { Product as SelectableProduct } from '../../services/ProductService';
import { QuotationProduct } from '../../types/Quotation';
import { formatToFloat } from '../../utils/formatCurrency';
import { NewProductModal } from '../../components/Product/NewProductModal';
import { Product } from '../../types/Product';
import { Product as GeneralProduct } from '../../types/Product';
import useNewProductForm from '../../hooks/newProductForm';

export type ListQuotationProductsProps = {
    quotationProducts: QuotationProduct[];
    setQuotationProducts: React.Dispatch<React.SetStateAction<QuotationProduct[]>>;
    quotationIsFinished?: boolean;
    changeTabIcon: (previousIcon: string) => void;
};

export function ListQuotationProducts({
    quotationProducts,
    setQuotationProducts,
    quotationIsFinished = false,
    changeTabIcon
}: ListQuotationProductsProps) {
    const { user } = useSelector((state: any) => state.auth);

    // Modal New Product
    const [productBeingCreated, setProductBeingCreated] = useState<{ index: number, product: QuotationProduct } | null>(null);
    const {
        showModalNewProduct, setShowModalNewProduct,
        newProductDefaultData, setNewProductDefaultData,
    } = useNewProductForm();

    const handleCreateProduct = useCallback((createdProduct: GeneralProduct) => {
        if (!productBeingCreated) return;

        const selectableProduct: SelectableProduct = {
            ...createdProduct as any,
            saleValue: formatToFloat(createdProduct.saleValue),
        };

        selectProduct(selectableProduct, productBeingCreated.index)
    }, [productBeingCreated]);
    
    const handleClickAddProduct = (typedText: string, index: number, product: QuotationProduct) => {
        setNewProductDefaultData({ nameProduct: typedText });
        setProductBeingCreated({ index, product })
        setShowModalNewProduct(true);
    };

    function addProducts() {
        var productsArray = quotationProducts;

        productsArray.push({
            id: 0,
            productId: 0,
            amount: 0,
            INSTANCE: {} as SelectableProduct,
        });

        setQuotationProducts([...productsArray]);
    }

    function deleteProduct(index: number) {
        var productsArray = quotationProducts;
        productsArray.splice(index, 1);
        setQuotationProducts([...productsArray]);
    }

    const selectProduct = useCallback(async (value: any, index: number) => {
        var productArray = quotationProducts;

        if (value) {
            var productsInKit = value.kit;
            var type = value.type;

            if (value.isKit == "y") {
                type = "kit";
            } else if (value.hasVariation == "y") {
                type = "variation";
            }

            productArray[index].productId = value.id;
            productArray[index].amount = 1;
            productArray[index].INSTANCE = {
                id: value.id,
                name: value.name,
                code: value.code,
                saleValue: value.saleValue,
                codeGtinEan: value.codeGtinEan,
                stockInitial: value.stockInitial,
                currentStock: formatToFloat(value.currentStock),
                hasVariation: value.hasVariation,
                isKit: value.isKit,
                kit: productsInKit,
                type: type
            };

        } else {
            productArray[index].productId = 0;
            productArray[index].amount = 0;
            productArray[index].INSTANCE = {
                id: 0,
                name: "",
                code: "",
                saleValue: 0,
                codeGtinEan: "",
                stockInitial: "",
                currentStock: 0,
                hasVariation: "",
                isKit: "",
                kit: "",
                type: "product"
            };
        }

        changeTabIcon('flaticon-open-box');
        setQuotationProducts([...productArray]);
    }, [quotationProducts]);

    function changeAmount(value: any, index: number) {
        var productArray = quotationProducts;
        productArray[index].amount = Number(value);

        setQuotationProducts([...productArray]);
    }

    return (
        <>
            <NewProductModal
                showModal={showModalNewProduct}
                setShowModal={setShowModalNewProduct}
                onCreateProduct={handleCreateProduct}
                defaultData={newProductDefaultData}
                allowChangeType={false}
            />
            <div className="row">
                <div className="col">
                    {
                        quotationProducts.map((product, index: number) => {
                            return (
                                <div className="row p-1" key={index}>
                                    <Grid item lg={4} md={6} xs={12} className='d-flex align-items-center'>
                                        <div className="mr-2 d-flex justify-content-center align-items-center bg-primary p-2 px-4 mt-2">
                                            <label className="text-white m-0">{index + 1}.</label>

                                            {
                                                product.INSTANCE.isKit == "y"
                                                    ?
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id='tooltip-top'>
                                                                <b>Produtos do Kit</b><br />
                                                                {product.INSTANCE.kit}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Button
                                                            size="sm"
                                                            variant="primary"
                                                            className="d-flex flex-row align-items-center justify-content-center ml-2 p-0"
                                                            style={{ padding: "5px", background: "transparent" }}
                                                        >
                                                            <i className="flaticon2-information m-0 p-0"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                    :
                                                    <></>
                                            }
                                        </div>

                                        <ProductSelect
                                            label="Produto"
                                            selectedProduct={product}
                                            onChangeProduct={(prod) => selectProduct(prod, index)}
                                            type="product"
                                            disabled={user.isAccountant == "y" ? true : false}
                                            onClickAddProduct={(typedText) => handleClickAddProduct(typedText, index, product)}
                                        />
                                    </Grid>

                                    <Grid item lg={2} md={6} xs={12}>
                                        <TextField
                                            type="number"
                                            size="small"
                                            label="Qtde."
                                            margin="normal"
                                            name="amount"

                                            value={product.amount}
                                            onChange={(evt) => changeAmount(evt.target.value, index)}
                                            disabled={user.isAccountant == "y" ? true : false}
                                        />
                                    </Grid>

                                    <>
                                        {
                                            (index > 0 && user.isAccountant == "n") && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link"
                                                    onClick={() => deleteProduct(index)}
                                                    title="Remover"
                                                >
                                                    <i className="flaticon-delete text-danger"></i>
                                                </button>
                                            )
                                        }
                                    </>
                                </div>
                            );
                        })
                    }
                </div>

                {
                    user.isAccountant == "n"
                    ?
                    <Grid item xs={12}>
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={() => addProducts()}
                        >
                            <ins>+ adicionar outro produto</ins>
                        </button>
                    </Grid>
                    : <></>
                }
            </div>
        </>
    );
}
